import React from 'react';

// GLOBAL VARIABLES
import { INTERFACE, REPORTS, RECORD, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from "react-router-dom";

// ROUTES
import List from './categories/List';
import Update from './categories/Update';

const paths = [
  makePath(RECORD.add),
  makePath(RECORD.edit, ':recordID')
];

// MAIN COMPONENT
const Reports = () => (
  <Routes>
    <Route path="/" element={<List />} />
    {paths.map((path, index) => <Route key={index} path={path} element={<Update />} />)}
    <Route path="*" element={<Navigate to={makePath(INTERFACE.settings, SETTINGS.reports, REPORTS.categories)} replace />} />
  </Routes>
)

// EXPORT
export default Reports;
